/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TelematicBoxDto } from '../../models/telematic-box-dto';
import { VehicleStatus } from '../../models/vehicle-status';

export interface UpdateBoxTelematicStatus$Params {
      body: VehicleStatus
}

export function updateBoxTelematicStatus(http: HttpClient, rootUrl: string, params: UpdateBoxTelematicStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<TelematicBoxDto>> {
  const rb = new RequestBuilder(rootUrl, updateBoxTelematicStatus.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TelematicBoxDto>;
    })
  );
}

updateBoxTelematicStatus.PATH = '/public/event/kmaster/box-services';
